import React from 'react';
import { Divider } from 'semantic-ui-react'

const HomeGer1 = ({autorizacUA, styles, handleClickSel11, handleClickSel12, handleClickSel13, handleClickSel14, handleClickSel15, 
                  handleClickSel16, handleClickSel17, handleClickSel18, handleClickSel19, handleClickSel20, handleClickSel21, 
                  handleClickSel22, handleClickSel23}) => {
  const a4005 = autorizacUA.findIndex( autorizac => autorizac === "4005" );
  const a4010 = autorizacUA.findIndex( autorizac => autorizac === "4010" );
  const a4015 = autorizacUA.findIndex( autorizac => autorizac === "4015" );
  const a4020 = autorizacUA.findIndex( autorizac => autorizac === "4020" );
  const a4025 = autorizacUA.findIndex( autorizac => autorizac === "4025" );
  const a4030 = autorizacUA.findIndex( autorizac => autorizac === "4030" );
  const a4035 = autorizacUA.findIndex( autorizac => autorizac === "4035" );
  const a4040 = autorizacUA.findIndex( autorizac => autorizac === "4040" );
  const a4045 = autorizacUA.findIndex( autorizac => autorizac === "4045" );
  const a4050 = autorizacUA.findIndex( autorizac => autorizac === "4050" );
  const a4055 = autorizacUA.findIndex( autorizac => autorizac === "4055" );

  return ( 
    <div>
      <button className="ui right labeled icon button fluid" style={styles.titBuscar}>
        <i className="large sitemap yellow icon"></i>
        GERENCIA
      </button>
      {a4045!==-1 &&
        <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel20}>
          <i className="large dollar sign red icon"></i>
          Seguimiento a turnos
        </button>
      }      
      <Divider inverted /> 
      {a4005!==-1 &&
        <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel11}>
          <i className="large flag checkered red icon"></i>
          Metas comerciales
        </button>
      }
      {a4010!==-1 &&
        <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel12}>
          <i className="large add to cart red icon"></i>
          Metas de facturación
        </button>
      }
      {a4015!==-1 &&
        <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel13}>
          <i className="large dollar sign red icon"></i>
          Metas de utilidades
        </button>
      }      
      <Divider inverted /> 
      {a4020!==-1 &&
        <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel14}>
          <i className="large file alternate outline red icon"></i>
          Seguimiento comercial
        </button>
      } 
      {a4025!==-1 &&
        <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel15}>
          <i className="large file alternate outline red icon"></i>
          Seguimiento logística
        </button>
      }
      {a4025!==-1 &&
        <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel18}>
          <i className="large file alternate outline red icon"></i>
          Seguimiento a traslados de productos
        </button>
      }      
      {a4030!==-1 &&
        <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel16}>
          <i className="large file alternate outline red icon"></i>
          Seguimiento facturación
        </button>
      }
      {a4050!==-1 &&
        <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel22}>
          <i className="large file alternate outline red icon"></i>
          Seguimiento tribología in house
        </button>
      }      
      {a4035!==-1 &&
        <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel17}>
            <i className="large searchengin red icon"></i>
            Tablero de control
        </button>
      }
      {a4040!==-1 &&
        <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel19}>
            <i className="large searchengin red icon"></i>
            Indicadores
        </button>
      }
      {a4055!==-1 &&
        <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel23}>
            <i className="large searchengin red icon"></i>
            Procesos pendientes
        </button>
      }
      {localStorage.getItem('userLogin')==="slcm@slcm.com" &&
        <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel21}>
            <i className="large searchengin red icon"></i>
            Descargar excel mes actual
        </button>
      }
    </div>
  )
};

export default HomeGer1
